import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { MARGIN_CACHE_KEYS } from "./keys";

import { UpdateMargin } from "@/types/margin";
import { MarginRepository } from "@/repositories/margin";

export const useUpdateMargin = () => {
  const queryClient = useQueryClient();
  const marginRepository = useRef(new MarginRepository());

  return useMutation({
    mutationFn: async (data: UpdateMargin) => {
      return await marginRepository.current.update(data);
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: MARGIN_CACHE_KEYS.LIST }),
  });
};
